import { render, staticRenderFns } from "./people-home.vue?vue&type=template&id=45851e2d&"
import script from "./people-home.vue?vue&type=script&lang=ts&"
export * from "./people-home.vue?vue&type=script&lang=ts&"
import style0 from "./people-home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports